import React from 'react';
import { useTransition } from 'react-spring';

import Toast from './Toast';

import { Container } from './styles';

const ToastContainer = ({ messages }) => {
    const validMessages = (messages || []).filter(msg => msg && msg.id);
    
    const transitions = useTransition(validMessages, {
        key: (item) => item.id,
        from: { right: '-120%', opacity: 0 },
        enter: { right: '0%', opacity: 1 },
        leave: { right: '-120%', opacity: 0 },
    });

    return (
        <Container>
            {transitions((style, item) => (
                <Toast key={item.id} message={item} style={style} />
            ))}
        </Container>
    );
};

export default ToastContainer;
